// Constantes compartidas para todos los formularios de jugadores
// Usar este archivo en: PlayerForm.js, Players.js (crear), PlayerDetail.js (editar)

export const POSITIONS = [
  "Arquero",
  "Defensa Central",
  "Lateral Derecho",
  "Lateral Izquierdo",
  "Volante",
  "Extremo Derecho",
  "Extremo Izquierdo",
  "Delantero Centro",
];

export const FOOT_OPTIONS = [
  { value: "Derecha", label: "Derecha" },
  { value: "Izquierda", label: "Izquierda" },
  { value: "Ambas", label: "Ambas" },
];

export const SHOE_SIZES = [
  "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5",
  "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13",
];

export const MEDICAL_COVERAGES = [
  "ASSE",
  "CASMU",
  "Médica Uruguaya",
  "COSEM",
  "Hospital Británico",
  "Círculo Católico",
  "Asociación Española",
  "MUCAM",
  "Crami",
  "Otra",
];

export const NATIONALITIES = [
  "Uruguayo/a",
  "Argentino/a",
  "Brasileño/a",
  "Paraguayo/a",
  "Colombiano/a",
  "Ecuatoriano/a",
  "Venezolano/a",
  "Peruano/a",
  "Boliviano/a",
  "Chileno/a",
  "Español/a",
  "Italiano/a",
  "Portugués/a",
  "Francés/a",
  "Alemán/a",
  "Inglés/a",
  "Otro",
];

export const COMMUNITY_PASSPORT_OPTIONS = [
  { value: "Si", label: "Sí" },
  { value: "No", label: "No" },
  { value: "Desconozco", label: "Desconozco" },
  { value: "En tramite", label: "En trámite" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Activo" },
  { value: "inactive", label: "Inactivo" },
  { value: "trial", label: "Prueba" },
];

export const ACADEMIC_PERFORMANCE_OPTIONS = [
  { value: "excelente", label: "Excelente" },
  { value: "bueno", label: "Bueno" },
  { value: "regular", label: "Regular" },
  { value: "necesita_apoyo", label: "Necesita Apoyo" },
];

// ── Helper: resolver valor cuando se eligió "Otro/Otra" ──────────────────
// Si el select muestra "Otra"/"Otro" y hay texto custom, guarda el texto custom.
// Sino, guarda el valor del select tal cual.
export function resolveOtherValue(selectValue, customText) {
  if ((selectValue === 'Otra' || selectValue === 'Otro') && customText && customText.trim()) {
    return customText.trim();
  }
  return selectValue;
}

// ── Helper: detecta si un valor de DB es un "otro" no estándar ───────────
// Para pre-cargar el campo al editar: si el valor no está en la lista, es custom.
export function isCustomValue(value, standardOptions) {
  if (!value) return false;
  const normalized = standardOptions.map(o => typeof o === 'string' ? o : o.value);
  return !normalized.includes(value);
}
